import { omit, pick } from 'lodash-es';

import { AppLinkProps } from './AppLink';

export function pickAppLinkProps(props: AppLinkProps) {
    return pick(props, [
        'href',
        'as',
        'replace',
        'scroll',
        'shallow',
        'prefetch',
        'locale',
        'onMouseEnter',
        'onTouchStart',
        'onClick',
    ]);
}

export function omitAppLinkProps(props: AppLinkProps) {
    return omit(props, [
        'href',
        'as',
        'replace',
        'scroll',
        'shallow',
        'prefetch',
        'locale',
        'onMouseEnter',
        'onTouchStart',
        'onClick',
    ]);
}
